import React from 'react'
import './Brand.css'

const Brand = () => {
  return (
    <div>Brand</div>
  )
}

export default Brand